// components/auth/AdminRoute.js - Role guard for tenant-admin-only pages
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { isAdmin } from '../constants/roles';

// Nest inside ProtectedRoute: it has already waited for user hydration, so userData.role is
// populated by the time this renders. Non-admins are redirected rather than shown the page,
// since hiding the sidebar link alone doesn't stop them typing the URL.
export const AdminRoute = () => {
  const { userData } = useUser();

  // userData.role is only the first entry of userData.roles, so check the full list too �
  // an admin whose admin role isn't listed first must not be locked out.
  const hasAdminAccess = isAdmin(userData?.role) || (userData?.roles || []).some(isAdmin);

  return hasAdminAccess ? <Outlet /> : <Navigate to="/dashboard" replace />;
};
